/** @jsxImportSource @emotion/react */

'use client';
import { Stack, type SxProps } from '@mui/material';
import { useEffect, useState } from 'react';

import { campaignManagerTheme } from '@campaign-manager/theme';

import * as styles from './styles';

interface Props {
  size?: 'small' | 'default';
  sx?: SxProps;
}

export default function Spinner({ size = 'default', sx }: Props) {
  const [activeIndex, setActiveIndex] = useState(-1);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((i) => (i + 1) % 5);
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <Stack
      direction="row"
      data-testid="loading-spinner"
      sx={[
        {
          gap: 0.5,
          alignItems: 'center',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {[0, 1, 2, 3].map((index: number) => (
        <div
          key={index}
          css={[
            styles.circle,
            {
              width: size === 'small' ? 4 : 15,
              height: size === 'small' ? 4 : 15,
              backgroundColor:
                activeIndex - 1 >= index
                  ? campaignManagerTheme.color.primary
                  : campaignManagerTheme.color.secondary,
            },
          ]}
        />
      ))}
    </Stack>
  );
}
